import React from 'react';
import InputField from './components/InputField'
import Header from './components/Header'
import { connect } from 'react-redux';

function GlobeInput({ onSubmit, loading, auth }) {
    return (
        <React.Fragment>
            {/*<h2 style={{ marginBottom: '10px' }}>Fetch news from a webpage</h2>
            <InputGroup className="group-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className="d-flex group-container_input">
                    <Input
                        onKeyPress={(e) => searchChange(e)}
                        onChange={(e) => searchChange(e)}
                        value={value}
                        placeholder="Enter the webpage URL"
                        type="text"
                        className="searchInput"
                        style={{ paddingRight: '30px' }}
                    />
                    {value && (
                        <i
                            style={{
                                cursor: 'pointer',
                                position: 'absolute',
                                top: '28%',
                            }}
                            onClick={() => handleChange('')}
                            className="fa fa-times-circle search-container_icon"
                        />
                    )}
                </div>
                <Button 
                    disabled={value.trim() === ''} 
                    style={{ color: 'white', minWidth: '110px' }} 
                    onClick={() => onSubmit(value)} className="btn typical-button target_input-btn"
                >
                    {loading ? <i className="fa fa-spinner fa-spin" /> : 'Create Fetch'}
                </Button>
            </InputGroup>
            */}
            <Header text="Fetch news from any webpage" />
            {auth.permissions && !auth.permissions.includes('vs') ?
                <div style={{ fontSize: '18px' }}>
                    To create newsfeeds from almost any website,<br/> contact Support to access this feature<br/>
                    <a style={{ textDecoration: 'underline' }} href="mailto:support@newsfetch.io">
                        support@newsfetch.io
                    </a>
                </div>
            :
                <InputField 
                    showSubmitGlass={true}
                    onSubmit={onSubmit} 
                    loading={loading}
                    inputPlaceholder="Enter the webpage URL" 
                />
            }
        </React.Fragment>
    );
}

const mapStateFromProps = (state) => ({
    auth: state.auth,
})

export default connect(mapStateFromProps, null)(GlobeInput);